import { GraphQLClient } from "graphql-request";

import Config from "~/config";
import offlineRequestMiddleware from "~/helpers/offline/offlineRequestMiddleware";

const publicClient = new GraphQLClient(Config.endpoint, {
	credentials: "omit",
	mode: "cors",
	requestMiddleware: offlineRequestMiddleware
});

export default publicClient;
